<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <span>Are you sure you want to delete {{ name }}?</span>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  components: {
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
    submitted () {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  data () {
    return {
      name: ''
    }
  },
  methods: {
    findUser() {
      let id = this.rowId

      return this.$store.dispatch('company/find', { id })
      .then(result => {
        if (result && result.data) {
          let { data } = result || {}
          this.name = data.name
        }
      })
      .catch(err => console.log(err))
    }
  },
  mounted(){
    if (this.rowId) {
      this.findUser()
    }
  },
}
</script>